export default __webpack_public_path__ + "static/media/cleanair.e1f7d91e.png";